import { Box, TextField, Typography, Autocomplete } from "@mui/material";
import { getAutocompleteInputProps, getInputLabelProps } from "../../../../common/Utils";
import styles from './Combobox.module.scss';

interface Props {
    fieldId: string;
    handleValueChange: any;
    fieldValue: any;
    fieldOptions: any;
    fieldLabel: string;
    customOptionLabel?: any;
    disabled?: boolean;
    optionFilter?: any;
    width?: string;
    errorMessage?: string;
}

export default function Combobox ({fieldId, fieldLabel, fieldValue, fieldOptions, handleValueChange, customOptionLabel, optionFilter, disabled, width, errorMessage }: Props) {
    return (
        <Box
        style={{width: width ?? '250px'}}
        >
            <Autocomplete
                style={{width: width ?? '250px'}}
                size="small"
                disabled={disabled}
                value={fieldValue}
                id={fieldId} 
                options={fieldOptions}
                fullWidth
                renderInput={(params: any) => (
                    <TextField {...params} error={!!errorMessage} InputProps={getAutocompleteInputProps(params.InputProps)} InputLabelProps={getInputLabelProps()} label={fieldLabel}/>
                )}
                getOptionLabel={customOptionLabel ?? ((option: any) => option?.Name ?? '')}
                isOptionEqualToValue={optionFilter ?? ((option: any, value: any) => option?.Id === value?.Id)}
                onChange={handleValueChange}
            />
            {errorMessage && (
                    <Typography className={styles.errorText}>
                        {errorMessage}
                    </Typography>
                )}
        </Box>
        
    )
}